// extracted by mini-css-extract-plugin
export var container = "_hq-0";
export var content = "_hq-3";
export var customerTitle = "_hq-4";
export var empty = "_hq-5";
export var gray = "_hq-6";
export var header = "_hq-7";
export var info = "_hq-8";
export var loading = "_hq-2";
export var loadingCard = "_hq-9";
export var oneLine = "_hq-a";
export var personName = "_hq-e";
export var pillContainer = "_hq-b";
export var selected = "_hq-1";
export var text = "_hq-c";
export var twoLines = "_hq-d";
export var unread = "_hq-f";
export var unreadIndicator = "_hq-g";